import { render, staticRenderFns } from "./shipmentRequestUpdate_bak.vue?vue&type=template&id=1820c184&scoped=true&"
import script from "./shipmentRequestUpdate_bak.vue?vue&type=script&lang=js&"
export * from "./shipmentRequestUpdate_bak.vue?vue&type=script&lang=js&"
import style0 from "./shipmentRequestUpdate_bak.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./shipmentRequestUpdate_bak.vue?vue&type=style&index=1&id=1820c184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820c184",
  null
  
)

export default component.exports